import * as React from 'react';
import { FastField, FieldProps } from 'formik';
import * as moment from 'moment';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components';

import { getInputClass } from './Input';
import { Icons } from '..';

const DateIcon = styled(Icons.Calendar).attrs(() => ({
  className: 'absolute pin-r mr-2 pointer-events-none',
}))`
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.theme.primary};
`;

const InputWrap = ({ children }: React.Props<{}>) => (
  <div className="relative">
    {children}
    <DateIcon />
  </div>
);

interface IInputProps {
  name?: string;
  className?: string;
  secondary?: boolean;
  small?: boolean;
  formatDateValue?: boolean;
  selected?: Date | null;
  required?: boolean;
}

export const FORMAT = 'DD.MM.YYYY';
const DATEPICKER_FORMAT = 'dd.MM.yyyy';

export const getDateFromValue = (value: string) => {
  return value ? moment(value, FORMAT).toDate() : null;
};

const onChangeDate =
  (onChange: any, name: string, formatDateValue: boolean) => (date: Date) => {
    if (formatDateValue) {
      const newDate = moment(date).format(FORMAT);
      onChange(name, newDate, false);
    } else {
      onChange(name, date, false);
    }
  };

const renderFormDate =
  ({
    className,
    secondary,
    small,
    formatDateValue = false,
    selected,
    ...props
  }: IInputProps) =>
  ({ form, field }: FieldProps) =>
    (
      <InputWrap>
        <DatePicker
          dateFormat={DATEPICKER_FORMAT}
          selected={getDateFromValue(field.value)}
          onChange={onChangeDate(
            form.setFieldValue,
            field.name,
            formatDateValue
          )}
          className={getInputClass({ className, secondary, small })}
          {...props}
        />
      </InputWrap>
    );

export const FormDateInput = ({ name, ...props }: IInputProps) => (
  <FastField name={name} render={renderFormDate(props)} />
);

export const DateInput = ({
  className = '',
  secondary,
  small,
  ...props
}: IInputProps & ReactDatePickerProps) => (
  <InputWrap>
    <DatePicker
      dateFormat={DATEPICKER_FORMAT}
      className={getInputClass({ className, secondary, small })}
      {...props}
    />
  </InputWrap>
);



// WEBPACK FOOTER //
// ./src/components/Form/Date.tsx